import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Users, Calendar, TrendingUp } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#09090b]">
      <div className="relative min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto text-center space-y-8">
          <div className="space-y-4">
            <h1 className="font-black tracking-tight">
              <span className="block text-5xl sm:text-6xl lg:text-7xl text-[#ccff00]">
                Trainers'
              </span>
              <span className="block text-2xl sm:text-3xl lg:text-4xl text-white manager-word">
                MANAGER
              </span>
            </h1>
            <p className="text-xl sm:text-2xl text-zinc-300 font-medium max-w-3xl mx-auto">
              Gestisci lezioni, atleti e costi in modo semplice e trasparente
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/register">
              <Button
                data-testid="get-started-btn"
                className="bg-[#ccff00] text-black hover:bg-[#b3e600] font-bold uppercase tracking-wide rounded-sm px-8 py-6 text-lg shadow-[0_0_15px_rgba(204,255,0,0.3)] hover:scale-105 transition-all"
              >
                Inizia Gratis
              </Button>
            </Link>
            <Link to="/login">
              <Button
                data-testid="login-btn"
                variant="outline"
                className="bg-zinc-800 text-white hover:bg-zinc-700 border border-zinc-700 rounded-sm px-8 py-6 text-lg"
              >
                Accedi
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="glass-card p-6 rounded-sm border border-white/10 hover:border-[#ccff00]/30 transition-colors group">
            <Activity className="w-12 h-12 text-[#ccff00] mb-4" />
            <h3 className="text-xl font-bold mb-2">Gestione Lezioni</h3>
            <p className="text-zinc-400">
              Crea e gestisci lezioni private con data, orario e durata personalizzata
            </p>
          </div>

          <div className="glass-card p-6 rounded-sm border border-white/10 hover:border-[#ccff00]/30 transition-colors group">
            <Users className="w-12 h-12 text-[#ccff00] mb-4" />
            <h3 className="text-xl font-bold mb-2">Atleti</h3>
            <p className="text-zinc-400">
              Invita e gestisci i tuoi atleti con visualizzazione trasparente dei costi
            </p>
          </div>

          <div className="glass-card p-6 rounded-sm border border-white/10 hover:border-[#ccff00]/30 transition-colors group">
            <Calendar className="w-12 h-12 text-[#ccff00] mb-4" />
            <h3 className="text-xl font-bold mb-2">Calcolo Automatico</h3>
            <p className="text-zinc-400">
              Calcolo automatico dei costi pro-capite basato su compenso e affitto pista
            </p>
          </div>

          <div className="glass-card p-6 rounded-sm border border-white/10 hover:border-[#ccff00]/30 transition-colors group">
            <TrendingUp className="w-12 h-12 text-[#ccff00] mb-4" />
            <h3 className="text-xl font-bold mb-2">Report PDF</h3>
            <p className="text-zinc-400">
              Esporta report dettagliati per atleta o per data in formato PDF
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
